// Deployment & Integration Roadmap: the lime timeline line fills top-to-bottom
// as the section scrolls, and each step lights up once the fill passes its dot.
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default function initRoadmap() {
  const lists = document.querySelectorAll('.roadmap__list');
  if (!lists.length) return;

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  lists.forEach((list) => {
    const progress = list.querySelector('.roadmap__progress');
    const steps = list.querySelectorAll('.roadmap-step');
    if (!progress) return;

    if (reduce) {
      progress.style.transform = 'scaleY(1)';
      steps.forEach((s) => s.classList.add('is-active'));
      return;
    }

    gsap.fromTo(
      progress,
      { scaleY: 0 },
      {
        scaleY: 1,
        ease: 'none',
        scrollTrigger: {
          trigger: list,
          start: 'top 78%',
          end: 'bottom 82%',
          scrub: 0.3,
          onUpdate: (self) => {
            const p = self.progress;
            steps.forEach((s, i) => {
              // Light a step once the fill reaches its dot (mid-row).
              const threshold = (i + 0.5) / steps.length;
              s.classList.toggle('is-active', p >= threshold);
            });
          },
        },
      }
    );
  });
}
